import React, { memo } from 'react';

import TVSetTopSelectable from '@r1-frontend/ui-react/organisms/Card/TVSetTopSelectable';

import { TProduct } from '~/src/features/full-buy/store/transformShopItem';

interface IProps {
    product: TProduct,
    isDisabled: boolean,
    openAddEquipmentPopup: (equipment: TProduct, isInstallmentDisabled: boolean) => void,
    handleDecrement: (id: number) => () => void,
    handleIncrement: (id: number) => () => void,
    isSkipImages?: boolean,
}

const DecoderCardView = ({
    product,
    isDisabled,
    openAddEquipmentPopup,
    handleDecrement,
    handleIncrement,
    isSkipImages,
}: IProps) => {
    const {
        id,
        image,
        images,
        title,
        categoryTitle,
        body,
        selectedPrice: { cost, duration },
        quantity,
    } = product;

    return <TVSetTopSelectable
        images={isSkipImages ? [image] : [image, ...images]}
        title={title}
        group={categoryTitle}
        description={body}
        cost={cost}
        period={duration}
        quantity={quantity}
        onButtonClick={() => openAddEquipmentPopup(product, true)}
        onIncrement={handleIncrement(id)}
        onDecrement={handleDecrement(id)}
        onCostClick={() => openAddEquipmentPopup(product, false)}
        btnText={'Подробнее'}
        disabled={isDisabled}
    />;
};

export default memo(DecoderCardView);
